import { useTheme } from "@emotion/react";
import React from "react";
import Close from "../../assets/icons/Close";
import FileIcon from "../../assets/icons/FileIcon";
import S from "./FileUpload.styled";
export default function FileUpload({ file, handleClose }) {
    var _a, _b, _c;
    const theme = useTheme();
    return (React.createElement(S.Wrapper, null,
        React.createElement(FileIcon, null),
        React.createElement(S.TextWrapper, null,
            React.createElement(S.FileName, null, file.name),
            React.createElement(S.FileExtension, null, (_c = (_b = (_a = file.type.split("/")) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) !== null && _c !== void 0 ? _c : "")),
        handleClose ? (React.createElement(S.CloseWrapper, { onClick: handleClose },
            React.createElement(Close, { fill: theme.color.backgroundBrand }))) : null));
}
//# sourceMappingURL=FileUpload.js.map